import $ from 'jquery';
import 'select2';
import { initOvdpSavePanel } from './ovdp_save';

$(function () {
    const $container = $('#ovdp-calculator-app');
    if (!$container.length) return;

    // Elements
    const $amountInput = $('#ovdp-amount-input');
    const $bondsCountInput = $('#ovdp-bonds-count-input');
    const $currencyAddon = $('.ovdp-currency-addon');
    const $tableSearch = $('#ovdp-table-search');
    const $tableCountBadge = $('#ovdp-table-count-badge');
    const $filterMax2y = $('#ovdp-filter-max-2y');
    const $bondSelect = $('#ovdp-bond-select');
    const $currencyTabs = $('.ovdp-currency-tab');
    const $bondPriceInput = $('#ovdp-bond-price-input');
    const $yieldInput = $('#ovdp-yield-input');
    const $tableContainer = $('#ovdp-table-container');
    const $vendorFilterBtns = $('.ovdp-vendor-filter-btn');
    let currentVendorFilter = 'all';
    let isSyncingFromTable = false;

    // Per-currency bond count temporary persistence (UAH, USD, EUR)
    const defaultCountsByCurrency = {
        UAH: 50,
        USD: 5,
        EUR: 5
    };
    const savedBondCountsByCurrency = { ...defaultCountsByCurrency };

    function getBondCurrency() {
        if (currentBond && currentBond.valCode) return currentBond.valCode.toUpperCase();
        if (currentCurrency && currentCurrency !== 'ALL') return currentCurrency.toUpperCase();
        return 'UAH';
    }

    function getSavedBondCount(currency) {
        let curr = (currency || 'UAH').toUpperCase();
        if (curr === 'ALL') {
            curr = (currentBond && currentBond.valCode) ? currentBond.valCode.toUpperCase() : 'UAH';
        }
        try {
            const stored = sessionStorage.getItem(`ovdp_bond_count_${curr}`);
            if (stored) {
                const val = parseInt(stored, 10);
                if (!isNaN(val) && val > 0) return val;
            }
        } catch (e) {}
        return savedBondCountsByCurrency[curr] || defaultCountsByCurrency[curr] || (curr === 'UAH' ? 50 : 5);
    }

    function saveBondCount(currency, count) {
        let curr = (currency || 'UAH').toUpperCase();
        if (curr === 'ALL') {
            curr = (currentBond && currentBond.valCode) ? currentBond.valCode.toUpperCase() : 'UAH';
        }
        const val = parseInt(count, 10);
        if (isNaN(val) || val < 1) return;
        savedBondCountsByCurrency[curr] = val;
        try {
            sessionStorage.setItem(`ovdp_bond_count_${curr}`, String(val));
        } catch (e) {}
    }

    function syncBondCountForCurrency(currency) {
        const targetCount = getSavedBondCount(currency);
        const bondPrice = getBondPrice();
        const targetAmount = targetCount * bondPrice;

        $bondsCountInput.val(targetCount);
        $amountInput.val(Math.round(targetAmount));

        renderPresets(currency, targetAmount);
        syncPresetButtonState(targetAmount);
    }

    // Vendor Panel elements
    const $vendorsPanel = $('#ovdp-vendors-panel');
    const $panelIsin = $('#ovdp-panel-isin');
    const $panelMilitaryBadge = $('#ovdp-panel-military-badge');
    const $panelMilName = $panelMilitaryBadge.find('.ovdp-panel-mil-name');
    const $panelVendorsList = $('#ovdp-panel-vendors-list');

    // Display elements
    const $displayBondCount = $('#ovdp-stat-bond-count');
    const $displayNetProfit = $('#ovdp-stat-net-profit');
    const $displayMonthlyIncome = $('#ovdp-stat-monthly-income');
    const $displayMonthlyRate = $('#ovdp-stat-monthly-rate');
    const $displayTotalPayout = $('#ovdp-stat-total-payout');
    const $displayAnnualYield = $('#ovdp-stat-annual-yield');
    const $displayActualYield = $('#ovdp-stat-actual-yield');
    const $displayDepositEquiv = $('#ovdp-stat-deposit-equiv');
    const $displayTaxSaved = $('#ovdp-stat-tax-saved');
    const $displayTermDesc = $('#ovdp-stat-term-desc');
    const $displayRepayDate = $('#ovdp-stat-repay-date');
    const $displayCurrencyLabels = $('.ovdp-currency-label');

    // Inflation controls & metrics
    const $inflationToggle = $('#ovdp-inflation-toggle');
    const $inflationInputs = $('.ovdp-inflation-input');
    const $inflationInputUah = $('#ovdp-inflation-input-uah');
    const $inflationInputUsd = $('#ovdp-inflation-input-usd');
    const $inflationInputEur = $('#ovdp-inflation-input-eur');
    const $inflationGroups = $('.ovdp-inflation-group');
    const $displayRealYield = $('#ovdp-stat-real-yield');
    const $displayRealNetProfit = $('#ovdp-stat-real-net-profit');
    const $displayRealPayout = $('#ovdp-stat-real-payout');
    const $displayCardRealYield = $('#ovdp-stat-card-real-yield');
    const $displayCardRealProfit = $('#ovdp-stat-card-real-profit');
    const $displayInflationLoss = $('#ovdp-stat-inflation-loss');
    const $displayCapitalShieldBadge = $('#ovdp-stat-capital-shield-badge');
    const $displayDepositRealYield = $('#ovdp-stat-deposit-real-yield');
    const $displayDepositRealDiff = $('#ovdp-stat-deposit-real-diff');
    const $inflationMetrics = $('.ovdp-inflation-metric');

    // Additional inflation analytical metrics & visual breakdown
    const $displayBreakevenInflation = $('#ovdp-stat-breakeven-inflation');
    const $displaySafetyMargin = $('#ovdp-stat-safety-margin');
    const $displayRealCapitalGrowth = $('#ovdp-stat-real-capital-growth');
    const $displayDoublingTime = $('#ovdp-stat-doubling-time');
    const $breakdownTotalLabel = $('#ovdp-breakdown-total-label');
    const $progressPrincipal = $('#ovdp-progress-principal');
    const $progressProfit = $('#ovdp-progress-profit');
    const $progressDrag = $('#ovdp-progress-drag');
    const $breakdownPrincipalVal = $('#ovdp-breakdown-principal-val');
    const $breakdownPrincipalPct = $('#ovdp-breakdown-principal-pct');
    const $breakdownProfitVal = $('#ovdp-breakdown-profit-val');
    const $breakdownProfitPct = $('#ovdp-breakdown-profit-pct');
    const $breakdownDragVal = $('#ovdp-breakdown-drag-val');
    const $breakdownDragPct = $('#ovdp-breakdown-drag-pct');

    // FX Devaluation Scenario elements
    const $fxScenarioRow = $('#ovdp-fx-scenario-row');
    const $fxCurrentRateInput = $('#ovdp-fx-current-rate');
    const $fxDevalInput = $('#ovdp-fx-deval-input');
    const $fxDevalRange = $('#ovdp-fx-deval-range');
    const $fxScaleLabels = $('.ovdp-fx-scale-label');
    const $fxProjectedRate = $('#ovdp-fx-stat-projected-rate');
    const $fxRateDiff = $('#ovdp-fx-stat-rate-diff');
    const $fxStatInvested = $('#ovdp-fx-stat-invested');
    const $fxStatPayout = $('#ovdp-fx-stat-payout');
    const $fxStatProfit = $('#ovdp-fx-stat-profit');
    const $fxStatYield = $('#ovdp-fx-stat-yield');
    const $fxStatRealPayout = $('#ovdp-fx-stat-real-payout');
    const $fxStatRealProfit = $('#ovdp-fx-stat-real-profit');
    const $fxStatRealYield = $('#ovdp-fx-stat-real-yield');
    const $fxStatUsdCpi = $('#ovdp-fx-stat-usd-cpi');
    const $fxStatRealSpread = $('#ovdp-fx-stat-real-spread');
    const $fxBadgeAdvantage = $('#ovdp-fx-badge-advantage');
    const $fxBreakevenRate = $('#ovdp-fx-stat-breakeven-rate');
    const $fxBreakevenDeval = $('#ovdp-fx-stat-breakeven-deval');
    const $fxSpreadBadge = $('#ovdp-fx-stat-spread-badge');

    // Payout Timeline & Schedule elements
    const $payoutCardRow = $('#ovdp-payout-card-row');
    const $payoutHeaderSubtitle = $('#ovdp-payout-header-subtitle');
    const $payoutFrequencyText = $('#ovdp-payout-frequency-text');
    const $payoutNextBadge = $('#ovdp-payout-next-badge');
    const $payoutNextText = $('#ovdp-payout-next-text');
    const $payoutTimelineWrapper = $('#ovdp-payout-timeline-wrapper');
    const $timelineProgressBar = $('#ovdp-timeline-progress-bar');
    const $timelineNodes = $('#ovdp-timeline-nodes');
    const $timelineStartLabel = $('#ovdp-timeline-start-label');
    const $timelineStatusLabel = $('#ovdp-timeline-status-label');
    const $timelineEndLabel = $('#ovdp-timeline-end-label');
    const $payoutEmptyState = $('#ovdp-payout-empty-state');
    const $payoutSummaryCoupons = $('#ovdp-payout-summary-coupons');
    const $payoutTableBody = $('#ovdp-payout-table-body');
    const $payoutToggleIcon = $('#ovdp-payout-toggle-icon');

    const textPayoutNextBadge = $container.data('text-payout-next-badge') || 'Next payout';
    const textPayoutRedemptionBadge = $container.data('text-payout-redemption-badge') || 'Principal redemption';
    const textPayoutCoupon = $container.data('text-payout-coupon') || 'Coupon';
    const textPayoutTimelineElapsed = $container.data('text-payout-timeline-elapsed') || 'Elapsed';
    const textPayoutTimelineRemaining = $container.data('text-payout-timeline-remaining') || 'Remaining';
    const textPayoutNoSchedule = $container.data('text-payout-no-schedule') || 'No schedule available';
    const textPayoutTotalCoupons = $container.data('text-payout-total-coupons') || 'Total coupons';
    const textPayoutStart = $container.data('text-payout-start') || 'Start';
    const textPayoutRedemptionLabel = $container.data('text-payout-redemption-label') || 'Maturity';
    const textPayoutPlusCoupon = $container.data('text-payout-plus-coupon') || '+ coupon';
    const textPayoutPaidStatus = $container.data('text-payout-paid-status') || 'Paid';
    const textPayoutColDate = $container.data('text-payout-col-date') || 'Payment Date';
    const textPayoutColType = $container.data('text-payout-col-type') || 'Payment Type';
    const textPayoutColAmount = $container.data('text-payout-col-amount') || 'Payout Amount';
    const textDays = $container.data('text-days') || 'days';
    const textMonths = $container.data('text-months') || 'months';
    const textYears = $container.data('text-years') || 'years';
    const textYearsShort = $container.data('text-years-short') || 'р.';

    const defaultUsdRate = parseFloat($container.data('usd-rate')) || 41.50;
    const benchmarkUsdYield = parseFloat($container.data('max-yield-usd')) || 3.15;

    const defaultInflationRates = {
        UAH: parseFloat($container.data('inflation-uah')) || 7.5,
        USD: parseFloat($container.data('inflation-usd')) || 2.9,
        EUR: parseFloat($container.data('inflation-eur')) || 2.2
    };

    function getInflationRateForCurrency(curr) {
        if (!$inflationToggle.is(':checked')) {
            return 0;
        }
        const c = (curr || 'UAH').toUpperCase();
        let $input = $inflationInputUah;
        if (c === 'USD') $input = $inflationInputUsd;
        else if (c === 'EUR') $input = $inflationInputEur;

        const val = parseFloat($input.val());
        return (isNaN(val) || val < 0) ? (defaultInflationRates[c] || 0) : val;
    }

    function syncInflationInputsVisibility() {
        if (currentCurrency === 'ALL') {
            $inflationGroups.show();
            const bondCurr = (currentBond && currentBond.valCode) ? currentBond.valCode.toLowerCase() : 'uah';
            $inflationGroups.removeClass('border border-primary rounded');
            $(`#ovdp-inflation-group-${bondCurr}`).addClass('border border-primary rounded');
        } else {
            $inflationGroups.hide().removeClass('border border-primary rounded');
            $(`#ovdp-inflation-group-${currentCurrency.toLowerCase()}`).show();
        }
    }

    // Sorting state
    let currentSort = {
        key: null,
        dir: 'asc'
    };

    // Parse bond data embedded in DOM
    let allBonds = [];
    try {
        const rawJson = $('#ovdp-initial-data').text();
        allBonds = JSON.parse(rawJson || '[]');
    } catch (e) {
        console.error('Failed to parse initial OVDP data', e);
        allBonds = [];
    }

    let currentCurrency = $container.data('selected-currency') || 'ALL';
    let currentBond = null;

    function getCurrencySymbol(code) {
        switch ((code || '').toUpperCase()) {
            case 'USD': return '$';
            case 'EUR': return '€';
            case 'UAH':
            default:
                return '₴';
        }
    }

    function formatNumber(val, decimals = 2) {
        if (isNaN(val) || val === null) return '0.00';
        return Number(val).toLocaleString(undefined, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    }

    function getBondPrice() {
        const val = parseFloat($bondPriceInput.val());
        if (!isNaN(val) && val > 0) return val;
        return (currentBond && currentBond.nominalValue > 0) ? currentBond.nominalValue : 1000;
    }

    function getYieldRate() {
        const val = parseFloat($yieldInput.val());
        if (!isNaN(val) && val >= 0) return val;
        return (currentBond && currentBond.incomeLevel > 0) ? currentBond.incomeLevel : 0;
    }

    function updateBondControlsFromCurrent() {
        if (!currentBond) return;
        const price = (currentBond.nominalValue > 0) ? currentBond.nominalValue : 1000;
        $bondPriceInput.val(price);
        $yieldInput.val(Number(currentBond.incomeLevel).toFixed(2));
    }

    function parseDateVal(val) {
        if (!val) return 0;
        const str = String(val).trim();
        if (str.includes('-')) {
            const parsed = Date.parse(str);
            if (!isNaN(parsed)) return parsed;
        }
        if (str.includes('.')) {
            const parts = str.split('.');
            if (parts.length === 3) {
                const d = parseInt(parts[0], 10);
                const m = parseInt(parts[1], 10) - 1;
                const y = parseInt(parts[2], 10);
                return new Date(y, m, d).getTime() || 0;
            }
        }
        return 0;
    }

    function recalculate(syncCount = false) {
        if (!currentBond) {
            const selectedIsin = $bondSelect.val();
            currentBond = allBonds.find(b => b.stockCode === selectedIsin) || allBonds[0];
            if (currentBond) {
                updateBondControlsFromCurrent();
            }
        }

        if (!currentBond) return;

        const bondPrice = getBondPrice();
        let investmentAmount = parseFloat($amountInput.val()) || 0;

        if (syncCount) {
            const calculatedCount = Math.max(1, Math.floor(investmentAmount / bondPrice));
            if ($bondsCountInput.length && document.activeElement !== $bondsCountInput[0]) {
                $bondsCountInput.val(calculatedCount);
            }
        }

        const bondCount = Math.max(1, parseInt($bondsCountInput.val(), 10) || Math.floor(investmentAmount / bondPrice) || 1);
        if (!syncCount && $amountInput.length && document.activeElement !== $amountInput[0]) {
            investmentAmount = bondCount * bondPrice;
            $amountInput.val(Math.round(investmentAmount));
        }
        const annualRate = getYieldRate();

        const daysToRepay = currentBond.daysToRepay || 0;
        const yearsToRepay = daysToRepay > 0 ? (daysToRepay / 365.25) : 1;
        const monthsToRepay = daysToRepay > 0 ? (daysToRepay / 30.4375) : 12;

        // Total Net Profit = Investment * (Annual Rate / 100) * (Days / 365.25)
        const netProfit = investmentAmount * (annualRate / 100) * yearsToRepay;
        const totalPayout = investmentAmount + netProfit;

        // Inflation Accounting (Fisher Equation & Purchasing Power Discount)
        const isInflationEnabled = $inflationToggle.is(':checked');
        const bondCurrency = (currentBond && currentBond.valCode) ? currentBond.valCode : 'UAH';
        const inflationPercent = getInflationRateForCurrency(bondCurrency);
        const inflationDecimal = inflationPercent / 100;

        let realAnnualRate = annualRate;
        let realPayout = totalPayout;
        let realNetProfit = netProfit;

        if (isInflationEnabled && inflationDecimal > 0) {
            const nominalDecimal = annualRate / 100;
            const realDecimal = ((1 + nominalDecimal) / (1 + inflationDecimal)) - 1;
            realAnnualRate = realDecimal * 100;

            const discountFactor = Math.pow(1 + inflationDecimal, yearsToRepay);
            realPayout = totalPayout / discountFactor;
            realNetProfit = realPayout - investmentAmount;
        }

        // Monthly equivalent income:
        const monthlyIncome = monthsToRepay > 0 ? (netProfit / monthsToRepay) : (netProfit / 12);
        const monthlyYieldPercent = annualRate / 12;

        // Bank Deposit Equivalent:
        // OVDP is tax-free (0%). Deposits have 18% PIT + 5% Military tax = 23% total tax.
        // Gross Deposit Rate = Annual Rate / (1 - 0.23) = Annual Rate / 0.77
        const depositEquivalentRate = annualRate / 0.77;

        // Tax saved vs bank deposit:
        const taxSaved = netProfit * (0.23 / 0.77);

        // Update UI
        const currSym = getCurrencySymbol(currentBond.valCode);
        $displayCurrencyLabels.text(currSym);
        $currencyAddon.text(currSym);

        $displayBondCount.text(formatNumber(bondCount, 0));
        $displayNetProfit.text(currSym + ' ' + formatNumber(netProfit, 2));
        $displayMonthlyIncome.text(currSym + ' ' + formatNumber(monthlyIncome, 2));
        $displayMonthlyRate.text(formatNumber(monthlyYieldPercent, 2) + '%');
        $displayTotalPayout.text(currSym + ' ' + formatNumber(totalPayout, 2));
        const actualHoldingYield = (investmentAmount > 0) ? ((netProfit / investmentAmount) * 100) : (annualRate * yearsToRepay);
        $displayAnnualYield.text(formatNumber(annualRate, 2) + '%');
        $displayActualYield.text(formatNumber(actualHoldingYield, 2) + '%');
        $displayDepositEquiv.text(formatNumber(depositEquivalentRate, 2) + '%');
        $displayTaxSaved.text(currSym + ' ' + formatNumber(taxSaved, 2));

        if (isInflationEnabled) {
            $inflationMetrics.show();
            $displayRealYield.text(formatNumber(realAnnualRate, 2) + '%');
            $displayRealNetProfit.text(currSym + ' ' + formatNumber(realNetProfit, 2));
            $displayRealPayout.text(currSym + ' ' + formatNumber(realPayout, 2));

            // Purchasing Power & Inflation Analysis Card metrics
            $displayCardRealYield.text(formatNumber(realAnnualRate, 2) + '%');
            $displayCardRealProfit.text(currSym + ' ' + formatNumber(realNetProfit, 2));
            const inflationLoss = Math.max(0, totalPayout - realPayout);
            $displayInflationLoss.text('-' + currSym + ' ' + formatNumber(inflationLoss, 2));

            // Capital protection status badge
            if (realAnnualRate > 0) {
                const textProtected = $container.data('text-capital-protected') || 'Capital protected from inflation';
                $displayCapitalShieldBadge.removeClass('bg-warning bg-danger text-dark').addClass('bg-success text-white')
                    .html('<i class="bx bx-check-shield me-1"></i>' + textProtected);
            } else {
                const textEroded = $container.data('text-capital-eroded') || 'Yield below inflation';
                $displayCapitalShieldBadge.removeClass('bg-success text-white').addClass('bg-warning text-dark')
                    .html('<i class="bx bx-error me-1"></i>' + textEroded);
            }

            // Bank Deposit real yield comparison
            // Deposit net nominal rate after 23% taxes = annualRate * 0.77
            const depositNetNominalRate = (annualRate * 0.77) / 100;
            const depositRealRate = (((1 + depositNetNominalRate) / (1 + inflationDecimal)) - 1) * 100;
            $displayDepositRealYield.text(formatNumber(depositRealRate, 2) + '%');
            const advantage = realAnnualRate - depositRealRate;
            $displayDepositRealDiff.text((advantage >= 0 ? '+' : '') + formatNumber(advantage, 2) + '%');

            // Additional analytical metrics:
            // 1. Breakeven inflation rate = annualRate
            $displayBreakevenInflation.text(formatNumber(annualRate, 2) + '%');

            // 2. Safety margin = annualRate - inflationPercent
            const safetyMargin = annualRate - inflationPercent;
            const marginPrefix = safetyMargin >= 0 ? '+' : '';
            $displaySafetyMargin.text(marginPrefix + formatNumber(safetyMargin, 1) + '%');
            if (safetyMargin >= 0) {
                $displaySafetyMargin.removeClass('bg-soft-danger text-danger bg-soft-warning text-warning')
                    .addClass('bg-soft-success text-success');
            } else {
                $displaySafetyMargin.removeClass('bg-soft-success text-success')
                    .addClass('bg-soft-danger text-danger');
            }

            // 3. Real capital growth % over the holding period:
            const realGrowthPct = investmentAmount > 0 ? (realNetProfit / investmentAmount) * 100 : 0;
            const growthPrefix = realGrowthPct >= 0 ? '+' : '';
            $displayRealCapitalGrowth.text(growthPrefix + formatNumber(realGrowthPct, 2) + '%');
            if (realGrowthPct >= 0) {
                $displayRealCapitalGrowth.removeClass('text-danger text-warning').addClass('text-success');
            } else {
                $displayRealCapitalGrowth.removeClass('text-success').addClass('text-danger');
            }

            // 4. Real doubling time (Rule of 72):
            const yearsShortText = $container.data('text-years-short') || 'р.';
            const doublingNaText = $container.data('text-doubling-na') || 'Не примножується';
            if (realAnnualRate > 0.05) {
                const doublingYears = (72 / realAnnualRate).toFixed(1);
                $displayDoublingTime.text(`~${doublingYears} ${yearsShortText}`).removeClass('text-muted font-size-13').addClass('text-info font-size-16');
            } else {
                $displayDoublingTime.text(doublingNaText).removeClass('text-info font-size-16').addClass('text-muted font-size-13');
            }

            // 5. Visual Payout Purchasing Power Breakdown Bar:
            $breakdownTotalLabel.text(currSym + ' ' + formatNumber(totalPayout, 2));
            const positiveRealProfit = Math.max(0, realNetProfit);

            let pctPrincipal = 0;
            let pctProfit = 0;
            let pctDrag = 0;

            if (totalPayout > 0) {
                pctPrincipal = Math.min(100, Math.round((investmentAmount / totalPayout) * 100));
                pctProfit = Math.min(100 - pctPrincipal, Math.round((positiveRealProfit / totalPayout) * 100));
                pctDrag = Math.max(0, 100 - pctPrincipal - pctProfit);
            }

            $progressPrincipal.css('width', pctPrincipal + '%');
            $progressProfit.css('width', pctProfit + '%');
            $progressDrag.css('width', pctDrag + '%');

            $breakdownPrincipalVal.text(currSym + ' ' + formatNumber(investmentAmount, 0));
            $breakdownPrincipalPct.text(pctPrincipal + '%');

            $breakdownProfitVal.text('+' + currSym + ' ' + formatNumber(positiveRealProfit, 0));
            $breakdownProfitPct.text(pctProfit + '%');

            $breakdownDragVal.text('-' + currSym + ' ' + formatNumber(inflationLoss, 0));
            $breakdownDragPct.text(pctDrag + '%');
        } else {
            $inflationMetrics.hide();
        }

        // FX Devaluation Scenario Analysis (for UAH bonds)
        const isUahBond = currentBond && currentBond.valCode === 'UAH';
        if (!isUahBond) {
            $fxScenarioRow.hide();
        } else {
            $fxScenarioRow.show();
            updateFxScenario(investmentAmount, totalPayout, annualRate, yearsToRepay);
        }

        const daysText = $container.data('text-days') || 'days';
        const monthsText = $container.data('text-months') || 'months';
        const approxMonths = Math.round(monthsToRepay);
        $displayTermDesc.text(daysToRepay + ' ' + daysText + ' (~' + approxMonths + ' ' + monthsText + ')');
        $displayRepayDate.text(currentBond.repayDate || '');

        // Highlight selected row in table
        $('.ovdp-table-row').removeClass('table-active');
        $(`.ovdp-table-row[data-isin="${currentBond.stockCode}"]`).addClass('table-active');

        // Update vendor panel in calculator
        renderVendorsPanel(currentBond);

        // Update payout timeline & schedule in calculator
        renderPayoutTimeline(currentBond, bondCount, currSym);
    }

    function updateFxScenario(investmentAmount, totalPayout, annualRate, yearsToRepay) {
        if (!$fxScenarioRow.length) return;

        let currentUsdRate = parseFloat($fxCurrentRateInput.val());
        if (isNaN(currentUsdRate) || currentUsdRate <= 0) {
            currentUsdRate = defaultUsdRate;
        }

        let devalAnnualRate = parseFloat($fxDevalInput.val());
        if (isNaN(devalAnnualRate)) {
            devalAnnualRate = 6.0;
        }

        const devalDec = devalAnnualRate / 100;
        const safeYears = yearsToRepay > 0 ? yearsToRepay : 1;

        // Compound maturity exchange rate: Rate_m = Rate_0 * (1 + deval)^t
        const projectedMaturityRate = currentUsdRate * Math.pow(1 + devalDec, safeYears);
        const rateDiff = projectedMaturityRate - currentUsdRate;
        const rateDiffPct = currentUsdRate > 0 ? ((projectedMaturityRate / currentUsdRate) - 1) * 100 : 0;

        $fxProjectedRate.text(formatNumber(projectedMaturityRate, 2) + ' ₴');
        const diffPrefix = rateDiff >= 0 ? '+' : '';
        $fxRateDiff.text(`${diffPrefix}${formatNumber(rateDiff, 2)} ₴ (${diffPrefix}${formatNumber(rateDiffPct, 1)}%)`);

        // USD Metrics
        const investedUsd = currentUsdRate > 0 ? (investmentAmount / currentUsdRate) : 0;
        const payoutUsd = projectedMaturityRate > 0 ? (totalPayout / projectedMaturityRate) : 0;
        const profitUsd = payoutUsd - investedUsd;

        $fxStatInvested.text('$ ' + formatNumber(investedUsd, 2));
        $fxStatPayout.text('$ ' + formatNumber(payoutUsd, 2));

        const profitPrefix = profitUsd >= 0 ? '+$ ' : '-$ ';
        $fxStatProfit.text(profitPrefix + formatNumber(Math.abs(profitUsd), 2));
        if (profitUsd >= 0) {
            $fxStatProfit.removeClass('text-danger').addClass('text-success');
        } else {
            $fxStatProfit.removeClass('text-success').addClass('text-danger');
        }

        // Annualized USD yield (CAGR)
        let annualYieldUsd = 0;
        if (investedUsd > 0 && payoutUsd > 0) {
            const growthRatio = payoutUsd / investedUsd;
            annualYieldUsd = (Math.pow(growthRatio, 1 / safeYears) - 1) * 100;
        } else if (investedUsd > 0) {
            annualYieldUsd = -100;
        }

        const yieldPrefix = annualYieldUsd >= 0 ? '+' : '';
        $fxStatYield.text(yieldPrefix + formatNumber(annualYieldUsd, 2) + '%');
        if (annualYieldUsd >= 0) {
            $fxStatYield.removeClass('text-danger').addClass('text-info');
        } else {
            $fxStatYield.removeClass('text-info').addClass('text-danger');
        }

        // Comparison with direct USD bonds
        const usdBenchmark = benchmarkUsdYield > 0 ? benchmarkUsdYield : 3.15;
        const spread = annualYieldUsd - usdBenchmark;
        const textBetter = $container.data('text-fx-better') || 'more profitable than USD bonds';
        const textWorse = $container.data('text-fx-worse') || 'inferior to USD bonds';
        const textVsUsd = $container.data('text-fx-vs-usd') || 'vs USD bonds';

        if (spread >= 0) {
            $fxBadgeAdvantage.removeClass('bg-warning text-dark bg-danger').addClass('bg-success text-white')
                .html(`<i class="bx bx-trending-up me-1"></i>+${formatNumber(spread, 2)}% ${textBetter} (${formatNumber(usdBenchmark, 2)}%)`);
        } else {
            $fxBadgeAdvantage.removeClass('bg-success text-white').addClass('bg-warning text-dark')
                .html(`<i class="bx bx-trending-down me-1"></i>${formatNumber(spread, 2)}% ${textWorse} (${formatNumber(usdBenchmark, 2)}%)`);
        }

        $fxSpreadBadge.text((spread >= 0 ? '+' : '') + formatNumber(spread, 2) + '% ' + textVsUsd);

        // Inflation-adjusted USD metrics
        const isInflationEnabled = $inflationToggle.is(':checked');
        const usdInflationRate = isInflationEnabled ? getInflationRateForCurrency('USD') : 0;
        const usdInflationDec = usdInflationRate / 100;

        if (isInflationEnabled && usdInflationDec > 0) {
            const usdDiscountFactor = Math.pow(1 + usdInflationDec, safeYears);
            const payoutUsdReal = usdDiscountFactor > 0 ? (payoutUsd / usdDiscountFactor) : payoutUsd;
            const profitUsdReal = payoutUsdReal - investedUsd;

            // Fisher equation for real USD yield: (1 + Y_usd) / (1 + i_usd) - 1
            const realYieldUsd = (((1 + (annualYieldUsd / 100)) / (1 + usdInflationDec)) - 1) * 100;
            const realBenchmarkUsd = (((1 + (usdBenchmark / 100)) / (1 + usdInflationDec)) - 1) * 100;
            const realSpread = realYieldUsd - realBenchmarkUsd;

            $fxStatRealPayout.text('$ ' + formatNumber(payoutUsdReal, 2));

            const realProfitPrefix = profitUsdReal >= 0 ? '+$ ' : '-$ ';
            $fxStatRealProfit.text(realProfitPrefix + formatNumber(Math.abs(profitUsdReal), 2));
            if (profitUsdReal >= 0) {
                $fxStatRealProfit.removeClass('text-danger').addClass('text-success');
            } else {
                $fxStatRealProfit.removeClass('text-success').addClass('text-danger');
            }

            const realYieldPrefix = realYieldUsd >= 0 ? '+' : '';
            $fxStatRealYield.text(realYieldPrefix + formatNumber(realYieldUsd, 2) + '%');
            if (realYieldUsd >= 0) {
                $fxStatRealYield.removeClass('text-danger').addClass('text-warning');
            } else {
                $fxStatRealYield.removeClass('text-warning').addClass('text-danger');
            }

            $fxStatUsdCpi.text(formatNumber(usdInflationRate, 1) + '%');

            const realSpreadPrefix = realSpread >= 0 ? '+' : '';
            $fxStatRealSpread.text(realSpreadPrefix + formatNumber(realSpread, 2) + '%');
            if (realSpread >= 0) {
                $fxStatRealSpread.removeClass('text-danger text-warning').addClass('text-success');
            } else {
                $fxStatRealSpread.removeClass('text-success').addClass('text-warning');
            }
        } else {
            $fxStatRealPayout.text('$ ' + formatNumber(payoutUsd, 2));
            const realProfitPrefix = profitUsd >= 0 ? '+$ ' : '-$ ';
            $fxStatRealProfit.text(realProfitPrefix + formatNumber(Math.abs(profitUsd), 2));
            $fxStatRealYield.text((annualYieldUsd >= 0 ? '+' : '') + formatNumber(annualYieldUsd, 2) + '%');
            $fxStatUsdCpi.text((defaultInflationRates.USD || 2.9).toFixed(1) + '%');
            $fxStatRealSpread.text((spread >= 0 ? '+' : '') + formatNumber(spread, 2) + '%');
        }

        // Breakeven Devaluation & Exchange Rate
        // (1 + Y_uah * t) / (1 + d_break)^t = 1 + Y_usd * t
        const uahNominalTotalFactor = 1 + (annualRate / 100) * safeYears;
        const usdNominalTotalFactor = 1 + (usdBenchmark / 100) * safeYears;
        const breakevenRatio = usdNominalTotalFactor > 0 ? (uahNominalTotalFactor / usdNominalTotalFactor) : 1;
        const breakevenDevalAnnual = (Math.pow(breakevenRatio, 1 / safeYears) - 1) * 100;
        const breakevenRate = currentUsdRate * breakevenRatio;

        $fxBreakevenRate.text(formatNumber(breakevenRate, 2) + ' ₴/$');
        const devalPrefix = breakevenDevalAnnual >= 0 ? '+' : '';
        $fxBreakevenDeval.text(devalPrefix + formatNumber(breakevenDevalAnnual, 1) + '%');
    }

    function syncFxScaleActive(val) {
        $fxScaleLabels.removeClass('active');
        $fxScaleLabels.filter(function () {
            const deval = parseFloat($(this).data('deval'));
            return Math.abs(deval - val) <= 1.0;
        }).addClass('active');
    }

    // FX Scenario controls event listeners
    $fxDevalRange.on('input', function () {
        const val = parseFloat($(this).val()) || 0;
        $fxDevalInput.val(val.toFixed(1));
        syncFxScaleActive(val);
        recalculate(false);
    });

    $fxDevalInput.on('input change', function () {
        const val = parseFloat($(this).val()) || 0;
        $fxDevalRange.val(val);
        syncFxScaleActive(val);
        recalculate(false);
    });

    $fxCurrentRateInput.on('input change', function () {
        recalculate(false);
    });

    $fxScaleLabels.on('click', function (e) {
        e.preventDefault();
        const deval = parseFloat($(this).data('deval')) || 0;
        $fxDevalInput.val(deval.toFixed(1));
        $fxDevalRange.val(deval);
        syncFxScaleActive(deval);
        recalculate(false);
    });

    const $thYieldLabel = $('#ovdp-th-yield-label');
    const $thYieldShort = $('#ovdp-th-yield-short');
    const $thActualLabel = $('#ovdp-th-actual-label');
    const $thActualShort = $('#ovdp-th-actual-short');

    function updateTableRealYields() {
        const isInflationEnabled = $inflationToggle.is(':checked');
        const nominalYieldText = $container.data('text-nominal-yield') || 'Annual yield';
        const nominalYieldShort = $container.data('text-nominal-short') || 'Annual %';
        const realAnnualText = $container.data('text-real-annual') || 'Real annual';
        const realAnnualShort = $container.data('text-real-annual-short') || 'Real ann. %';
        const realText = $container.data('text-real-yield') || 'Real yield';
        const realShort = $container.data('text-real-short') || 'Real %';
        const actualText = $container.data('text-actual-yield') || 'Actual yield';
        const actualShort = $container.data('text-actual-short') || 'Actual %';

        if (isInflationEnabled) {
            $thYieldLabel.html('<i class="bx bx-shield-quarter text-warning me-1"></i>' + realAnnualText);
            $thYieldShort.html('<i class="bx bx-shield-quarter text-warning me-1"></i>' + realAnnualShort);
            $thActualLabel.html('<i class="bx bx-shield-quarter text-warning me-1"></i>' + realText);
            $thActualShort.html('<i class="bx bx-shield-quarter text-warning me-1"></i>' + realShort);
        } else {
            $thYieldLabel.text(nominalYieldText);
            $thYieldShort.text(nominalYieldShort);
            $thActualLabel.text(actualText);
            $thActualShort.text(actualShort);
        }

        const uahRate = getInflationRateForCurrency('UAH');
        const usdRate = getInflationRateForCurrency('USD');
        const eurRate = getInflationRateForCurrency('EUR');

        $('.ovdp-table-row').each(function () {
            const $row = $(this);
            const $yieldBadge = $row.find('.ovdp-table-yield-badge');
            const $actualBadge = $row.find('.ovdp-table-actual-badge');
            if (!$actualBadge.length && !$yieldBadge.length) return;

            if (!isInflationEnabled) {
                if ($yieldBadge.length) {
                    const initialYield = $yieldBadge.data('initial-yield') || (parseFloat($row.data('yield')).toFixed(2) + '%');
                    $yieldBadge.removeClass('bg-soft-warning text-warning bg-soft-danger text-danger bg-warning text-white bg-soft-success')
                        .addClass('bg-success text-white')
                        .removeAttr('title')
                        .text(initialYield);
                }
                if ($actualBadge.length) {
                    const initialVal = $actualBadge.data('initial-actual') || (parseFloat($row.data('actual-yield')).toFixed(2) + '%');
                    $actualBadge.removeClass('bg-soft-warning text-warning bg-soft-danger text-danger bg-warning text-white')
                        .addClass('bg-soft-success text-success')
                        .removeAttr('title')
                        .text(initialVal);
                }
                $row.attr('data-real-yield', 0).data('real-yield', 0);
                $row.attr('data-real-annual-yield', 0).data('real-annual-yield', 0);
                return;
            }

            const rowCurr = ($row.data('currency') || 'UAH').toUpperCase();
            let rowInflationPercent = uahRate;
            if (rowCurr === 'USD') rowInflationPercent = usdRate;
            else if (rowCurr === 'EUR') rowInflationPercent = eurRate;

            const rowInflationDecimal = rowInflationPercent / 100;
            const bondYield = parseFloat($row.data('yield')) || 0;
            const daysToRepay = parseInt($row.data('term'), 10) || 0;
            const yearsToRepay = daysToRepay > 0 ? (daysToRepay / 365.25) : 0;

            // Nominal holding period yield (factor: 1 + Y_annual * yearsToRepay)
            const nominalHoldingRate = parseFloat($row.data('actual-yield')) || (bondYield * yearsToRepay);
            const nominalHoldingFactor = 1 + (nominalHoldingRate / 100);

            // Cumulative inflation discount over the holding period: (1 + i)^t
            const inflationDiscountFactor = yearsToRepay > 0 ? Math.pow(1 + rowInflationDecimal, yearsToRepay) : 1;

            // Real holding period yield over the exact term to maturity:
            const realHoldingFactor = inflationDiscountFactor > 0 ? (nominalHoldingFactor / inflationDiscountFactor) : nominalHoldingFactor;
            const realRate = (realHoldingFactor - 1) * 100;

            // Annualized real rate (via Fisher equation): ((1 + r) / (1 + i) - 1) * 100
            const realAnnualRate = (((1 + (bondYield / 100)) / (1 + rowInflationDecimal)) - 1) * 100;

            $row.attr('data-real-yield', realRate).data('real-yield', realRate);
            $row.attr('data-real-annual-yield', realAnnualRate).data('real-annual-yield', realAnnualRate);

            const annualPrefix = realAnnualRate > 0 ? '+' : '';
            const tooltip = `${rowCurr} inflation: ${formatNumber(rowInflationPercent, 1)}% (${annualPrefix}${formatNumber(realAnnualRate, 2)}% annual real)`;
            const prefix = realRate > 0 ? '+' : '';

            // Update Annual Yield badge (Column 3)
            if ($yieldBadge.length) {
                if (realAnnualRate > 0) {
                    $yieldBadge.removeClass('bg-success text-white bg-soft-warning text-warning bg-soft-danger text-danger')
                        .addClass('bg-soft-success text-success')
                        .attr('title', tooltip)
                        .html(`<i class="bx bx-check-shield me-1"></i>${annualPrefix}${formatNumber(realAnnualRate, 2)}%`);
                } else {
                    $yieldBadge.removeClass('bg-success text-white bg-soft-success text-success')
                        .addClass('bg-soft-warning text-warning')
                        .attr('title', tooltip)
                        .html(`<i class="bx bx-error me-1"></i>${annualPrefix}${formatNumber(realAnnualRate, 2)}%`);
                }
            }

            // Update Holding Period Yield badge (Column 4)
            if ($actualBadge.length) {
                if (realRate > 0) {
                    $actualBadge.removeClass('bg-soft-warning text-warning bg-soft-danger text-danger')
                        .addClass('bg-soft-success text-success')
                        .attr('title', tooltip)
                        .html(`<i class="bx bx-check-shield me-1"></i>${prefix}${formatNumber(realRate, 2)}%`);
                } else {
                    $actualBadge.removeClass('bg-soft-success text-success')
                        .addClass('bg-soft-warning text-warning')
                        .attr('title', tooltip)
                        .html(`<i class="bx bx-error me-1"></i>${prefix}${formatNumber(realRate, 2)}%`);
                }
            }
        });
    }

    function initSelect2() {
        if (typeof $.fn.select2 === 'function') {
            if ($bondSelect.hasClass('select2-hidden-accessible')) {
                try { $bondSelect.select2('destroy'); } catch (e) {}
            }
            $bondSelect.next('.select2-container').remove();
            $bondSelect.select2({
                width: '100%',
                minimumResultsForSearch: 0
            });
        }
    }

    function populateBondSelect(currency) {
        if (typeof $.fn.select2 === 'function' && $bondSelect.hasClass('select2-hidden-accessible')) {
            try { $bondSelect.select2('destroy'); } catch (e) {}
        }
        $bondSelect.next('.select2-container').remove();

        $bondSelect.empty();
        const hideLongTerm = $filterMax2y.is(':checked');
        let filtered = (currency === 'ALL')
            ? allBonds
            : allBonds.filter(b => b.valCode === currency);

        if (hideLongTerm) {
            const shortFiltered = filtered.filter(b => (b.daysToRepay || 0) <= 732);
            if (shortFiltered.length > 0) {
                filtered = shortFiltered;
            }
        }

        if (filtered.length === 0) {
            $bondSelect.append($('<option>').text($container.data('text-no-bonds') || 'No active bonds').val(''));
            currentBond = null;
            initSelect2();
            return;
        }

        filtered.forEach(b => {
            const label = b.militaryName
                ? `🇺🇦 ${b.militaryName} | ${b.stockCode} (${b.valCode}) - ${b.incomeLevel}% | ${b.repayDate}`
                : `${b.stockCode} (${b.valCode}) - ${b.incomeLevel}% | ${b.repayDate} (${b.bucket || ''})`;
            const $opt = $('<option>').val(b.stockCode).text(label);
            $bondSelect.append($opt);
        });

        const exists = currentBond && filtered.some(b => b.stockCode === currentBond.stockCode);
        if (!exists) {
            currentBond = filtered[0];
        }
        $bondSelect.val(currentBond.stockCode);
        initSelect2();
    }

    function filterTable() {
        const query = ($tableSearch.val() || '').trim().toLowerCase();
        const hideLongTerm = $filterMax2y.is(':checked');
        let visibleCount = 0;

        $('.ovdp-table-row').each(function () {
            const $row = $(this);
            const rowCurr = $row.data('currency');
            const termDays = parseInt($row.data('term'), 10) || 0;
            const currencyMatch = (currentCurrency === 'ALL') || (rowCurr === currentCurrency);

            if (!currencyMatch) {
                $row.hide();
                return;
            }

            if (hideLongTerm && termDays > 732) {
                $row.hide();
                return;
            }

            if (currentVendorFilter === 'available') {
                const vendorsStr = ($row.data('vendors') || '').toString().trim();
                if (!vendorsStr || vendorsStr.length === 0) {
                    $row.hide();
                    return;
                }
            } else if (currentVendorFilter === 'diia') {
                const isMilitary = $row.data('is-military') === true || $row.attr('data-is-military') === 'true';
                const vendorsStr = ($row.data('vendors') || '').toString();
                if (!isMilitary && !vendorsStr.includes('diia')) {
                    $row.hide();
                    return;
                }
            } else if (currentVendorFilter === 'brokers') {
                const vendorsStr = ($row.data('vendors') || '').toString();
                if (!vendorsStr.includes('icu') && !vendorsStr.includes('univer')) {
                    $row.hide();
                    return;
                }
            }

            if (!query) {
                $row.show();
                visibleCount++;
                return;
            }

            const rowText = $row.text().toLowerCase();
            const isin = ($row.data('isin') || '').toLowerCase();
            if (rowText.includes(query) || isin.includes(query)) {
                $row.show();
                visibleCount++;
            } else {
                $row.hide();
            }
        });

        if ($tableCountBadge.length) {
            const $num = $tableCountBadge.find('.ovdp-count-num');
            if ($num.length) {
                $num.text(visibleCount);
            } else {
                $tableCountBadge.text(visibleCount);
            }
        }
    }

    function sortTableRows() {
        if (!currentSort.key) return;

        const $tbody = $('#ovdp-bonds-table tbody');
        const rows = $tbody.children('.ovdp-table-row').get();

        rows.sort(function (a, b) {
            const $a = $(a);
            const $b = $(b);

            let res = 0;
            switch (currentSort.key) {
                case 'isin': {
                    const aVal = ($a.data('isin') || '').toString().toLowerCase();
                    const bVal = ($b.data('isin') || '').toString().toLowerCase();
                    res = aVal.localeCompare(bVal);
                    break;
                }
                case 'currency': {
                    const aVal = ($a.data('currency') || '').toString().toLowerCase();
                    const bVal = ($b.data('currency') || '').toString().toLowerCase();
                    res = aVal.localeCompare(bVal);
                    break;
                }
                case 'yield': {
                    if ($inflationToggle.is(':checked')) {
                        const aVal = parseFloat($a.attr('data-real-annual-yield') || $a.data('real-annual-yield')) || 0;
                        const bVal = parseFloat($b.attr('data-real-annual-yield') || $b.data('real-annual-yield')) || 0;
                        res = aVal - bVal;
                    } else {
                        const aVal = parseFloat($a.data('yield')) || 0;
                        const bVal = parseFloat($b.data('yield')) || 0;
                        res = aVal - bVal;
                    }
                    break;
                }
                case 'actual-yield': {
                    if ($inflationToggle.is(':checked')) {
                        const aVal = parseFloat($a.attr('data-real-yield') || $a.data('real-yield')) || 0;
                        const bVal = parseFloat($b.attr('data-real-yield') || $b.data('real-yield')) || 0;
                        res = aVal - bVal;
                    } else {
                        const aVal = parseFloat($a.data('actual-yield')) || 0;
                        const bVal = parseFloat($b.data('actual-yield')) || 0;
                        res = aVal - bVal;
                    }
                    break;
                }
                case 'term': {
                    const aVal = parseInt($a.data('term'), 10) || 0;
                    const bVal = parseInt($b.data('term'), 10) || 0;
                    res = aVal - bVal;
                    break;
                }
                case 'repay': {
                    const aVal = parseDateVal($a.data('repay'));
                    const bVal = parseDateVal($b.data('repay'));
                    res = aVal - bVal;
                    break;
                }
                case 'auction': {
                    const aVal = parseDateVal($a.data('auction'));
                    const bVal = parseDateVal($b.data('auction'));
                    res = aVal - bVal;
                    break;
                }
                default:
                    res = 0;
            }

            return currentSort.dir === 'asc' ? res : -res;
        });

        $tbody.append(rows);

        // Update sort indicators on headers
        $('.ovdp-sortable-th').each(function () {
            const $th = $(this);
            const key = $th.data('sort-key');
            const $icon = $th.find('.sort-icon');

            if (key === currentSort.key) {
                $icon.removeClass('bx-sort bx-sort-up bx-sort-down opacity-50')
                     .addClass(currentSort.dir === 'asc' ? 'bx-sort-up text-primary' : 'bx-sort-down text-primary');
            } else {
                $icon.removeClass('bx-sort-up bx-sort-down text-primary')
                     .addClass('bx-sort opacity-50');
            }
        });
    }

    // Sort header click event
    $(document).on('click', '.ovdp-sortable-th', function () {
        const key = $(this).data('sort-key');
        if (!key) return;

        if (currentSort.key === key) {
            currentSort.dir = (currentSort.dir === 'asc') ? 'desc' : 'asc';
        } else {
            currentSort.key = key;
            currentSort.dir = (key === 'yield' || key === 'actual-yield') ? 'desc' : 'asc';
        }

        sortTableRows();
    });

    function scrollToTableRow(isin) {
        if (!isin) return;
        let $row = $(`.ovdp-table-row[data-isin="${isin}"]`);
        if (!$row.length) return;

        // If row is hidden by search filter, reset search filter so user sees the row
        if ($row.is(':hidden') && $tableSearch.val()) {
            $tableSearch.val('');
            filterTable();
            $row = $(`.ovdp-table-row[data-isin="${isin}"]`);
        }

        // If row is hidden by 2-year filter, uncheck filter so user sees the row
        if ($row.is(':hidden') && $filterMax2y.is(':checked')) {
            $filterMax2y.prop('checked', false);
            filterTable();
            $row = $(`.ovdp-table-row[data-isin="${isin}"]`);
        }

        if (!$row.length || $row.is(':hidden')) return;

        $('.ovdp-table-row').removeClass('table-active');
        $row.addClass('table-active');

        if ($tableContainer.length) {
            const containerEl = $tableContainer[0];
            const rowEl = $row[0];
            const rowOffsetTop = rowEl.offsetTop;
            const containerHeight = containerEl.clientHeight;
            const rowHeight = rowEl.offsetHeight;

            const targetScrollTop = rowOffsetTop - (containerHeight / 2) + (rowHeight / 2);

            $tableContainer.stop().animate({
                scrollTop: Math.max(0, targetScrollTop)
            }, 350);

            // Flash highlight pulse animation
            $row.removeClass('ovdp-row-highlight');
            void rowEl.offsetWidth; // force browser reflow
            $row.addClass('ovdp-row-highlight');
            setTimeout(() => {
                $row.removeClass('ovdp-row-highlight');
            }, 1600);
        }
    }

    // Presets configuration
    const PRESETS = {
        UAH: [
            { amount: 10000, label: '10,000' },
            { amount: 50000, label: '50,000' },
            { amount: 100000, label: '100,000' },
            { amount: 500000, label: '500,000' }
        ],
        FX: [
            { amount: 1000, label: '1,000' },
            { amount: 5000, label: '5,000' },
            { amount: 10000, label: '10,000' },
            { amount: 50000, label: '50,000' }
        ]
    };

    function isFxCurrency(curr) {
        if (curr === 'USD' || curr === 'EUR') return true;
        if (curr === 'ALL' && currentBond && (currentBond.valCode === 'USD' || currentBond.valCode === 'EUR')) return true;
        return false;
    }

    function renderPresets(curr, currentAmount) {
        const $container = $('#ovdp-preset-container');
        if (!$container.length) return;

        const isFx = isFxCurrency(curr);
        const list = isFx ? PRESETS.FX : PRESETS.UAH;

        $container.empty();
        list.forEach(p => {
            const isMatch = Math.abs(currentAmount - p.amount) < 0.01;
            const btnClass = isMatch ? 'btn-primary' : 'btn-outline-primary';
            $container.append(
                $('<button>', {
                    type: 'button',
                    class: `btn btn-sm ${btnClass} ovdp-preset-btn`,
                    'data-amount': p.amount,
                    text: p.label
                })
            );
        });
    }

    function syncPresetButtonState(amount) {
        $('.ovdp-preset-btn').each(function () {
            const btnAmount = parseFloat($(this).attr('data-amount')) || parseFloat($(this).data('amount'));
            if (Math.abs(btnAmount - amount) < 0.01) {
                $(this).removeClass('btn-outline-primary').addClass('btn-primary');
            } else {
                $(this).removeClass('btn-primary').addClass('btn-outline-primary');
            }
        });
    }

    // Event Handlers for bidirectional inputs
    $amountInput.on('input change', function () {
        const bondPrice = getBondPrice();
        const amount = parseFloat($(this).val()) || 0;
        const count = Math.max(1, Math.floor(amount / bondPrice));
        if ($bondsCountInput.length) {
            $bondsCountInput.val(count);
        }
        saveBondCount(getBondCurrency(), count);
        syncPresetButtonState(amount);
        recalculate(false);
    });

    $bondsCountInput.on('input change', function () {
        const bondPrice = getBondPrice();
        let count = parseInt($(this).val(), 10);
        if (isNaN(count) || count < 1) {
            count = 1;
        }
        const amount = count * bondPrice;
        $amountInput.val(Math.round(amount));
        saveBondCount(getBondCurrency(), count);
        syncPresetButtonState(amount);
        recalculate(false);
    });

    $bondPriceInput.on('input change', function () {
        const bondPrice = getBondPrice();
        const count = parseInt($bondsCountInput.val(), 10) || 1;
        $amountInput.val(Math.round(count * bondPrice));
        syncPresetButtonState(parseFloat($amountInput.val()) || 0);
        recalculate(false);
    });

    $yieldInput.on('input change', function () {
        recalculate(false);
    });

    // Table instant search
    $tableSearch.on('input', function () {
        filterTable();
    });

    // Up to 2 years filter toggle
    $filterMax2y.on('change', function () {
        populateBondSelect(currentCurrency);
        filterTable();
        recalculate(false);
    });

    $bondSelect.on('change', function () {
        const isin = $(this).val();
        if (!isin || (currentBond && currentBond.stockCode === isin)) return;

        const oldCurr = getBondCurrency();
        const nextBond = allBonds.find(b => b.stockCode === isin);
        if (nextBond) {
            const newCurr = (nextBond.valCode || 'UAH').toUpperCase();
            if (oldCurr !== newCurr) {
                const currentCount = parseInt($bondsCountInput.val(), 10);
                if (!isNaN(currentCount) && currentCount > 0) {
                    saveBondCount(oldCurr, currentCount);
                }
            }

            currentBond = nextBond;

            if (currentCurrency !== 'ALL' && currentBond.valCode !== currentCurrency) {
                currentCurrency = currentBond.valCode;
                $currencyTabs.removeClass('active');
                $(`.ovdp-currency-tab[data-currency="${currentBond.valCode}"]`).addClass('active');
                filterTable();
            }

            updateBondControlsFromCurrent();

            if (oldCurr !== newCurr) {
                syncBondCountForCurrency(newCurr);
            } else {
                const currentCount = parseInt($bondsCountInput.val(), 10) || getSavedBondCount(newCurr);
                const bondPrice = getBondPrice();
                const newAmount = currentCount * bondPrice;
                $amountInput.val(Math.round(newAmount));
                syncPresetButtonState(newAmount);
            }

            syncInflationInputsVisibility();
        }
        recalculate(false);
        if (!isSyncingFromTable) {
            scrollToTableRow(isin);
        }
    });

    $(document).on('click', '.ovdp-preset-btn', function () {
        const amount = parseFloat($(this).attr('data-amount')) || parseFloat($(this).data('amount'));
        if (amount) {
            $amountInput.val(amount);
            const bondPrice = getBondPrice();
            const count = Math.max(1, Math.floor(amount / bondPrice));
            if ($bondsCountInput.length) {
                $bondsCountInput.val(count);
            }
            saveBondCount(getBondCurrency(), count);
            $('.ovdp-preset-btn').removeClass('btn-primary').addClass('btn-outline-primary');
            $(this).removeClass('btn-outline-primary').addClass('btn-primary');
            recalculate(false);
        }
    });

    $inflationToggle.on('change', function () {
        const isChecked = $(this).is(':checked');
        $inflationInputs.prop('disabled', !isChecked);
        if (isChecked) {
            const bondCurr = (currentBond && currentBond.valCode) ? currentBond.valCode.toLowerCase() : 'uah';
            $(`#ovdp-inflation-input-${bondCurr}`).focus();
        }
        recalculate(false);
        updateTableRealYields();
    });

    $inflationInputs.on('input change', function () {
        recalculate(false);
        updateTableRealYields();
    });

    // Reset button: resets UAH to NBU, USD to 2.9%, EUR to 2.2%
    $(document).on('click', '#ovdp-scenario-reset', function (e) {
        e.preventDefault();
        $inflationInputUah.val(defaultInflationRates.UAH.toFixed(1));
        $inflationInputUsd.val(defaultInflationRates.USD.toFixed(1));
        $inflationInputEur.val(defaultInflationRates.EUR.toFixed(1));
        recalculate(false);
        updateTableRealYields();
    });

    function switchCurrencyTab(currency) {
        const prevBondCurrency = getBondCurrency();
        const currentCount = parseInt($bondsCountInput.val(), 10);
        if (!isNaN(currentCount) && currentCount > 0) {
            saveBondCount(prevBondCurrency, currentCount);
        }

        currentCurrency = currency;
        $currencyTabs.removeClass('active');
        $(`.ovdp-currency-tab[data-currency="${currency}"]`).addClass('active');

        syncInflationInputsVisibility();
        populateBondSelect(currency);
        filterTable();
        updateBondControlsFromCurrent();

        const effectiveCurrency = getBondCurrency();
        syncBondCountForCurrency(effectiveCurrency);

        recalculate(false);
        updateTableRealYields();
    }

    $currencyTabs.on('click', function (e) {
        e.preventDefault();
        const currency = $(this).data('currency');
        switchCurrencyTab(currency);
    });

    // Handle click on table rows
    $(document).on('click', '.ovdp-table-row', function () {
        const isin = $(this).data('isin');
        if (!isin) return;

        const bond = allBonds.find(b => b.stockCode === isin);
        if (bond) {
            const oldCurr = getBondCurrency();
            const newCurr = (bond.valCode || 'UAH').toUpperCase();
            if (oldCurr !== newCurr) {
                const currentCount = parseInt($bondsCountInput.val(), 10);
                if (!isNaN(currentCount) && currentCount > 0) {
                    saveBondCount(oldCurr, currentCount);
                }
            }

            currentBond = bond;
            if (currentCurrency !== 'ALL' && currentBond.valCode !== currentCurrency) {
                currentCurrency = currentBond.valCode;
                $currencyTabs.removeClass('active');
                $(`.ovdp-currency-tab[data-currency="${currentBond.valCode}"]`).addClass('active');
                populateBondSelect(currentBond.valCode);
                filterTable();
            }

            isSyncingFromTable = true;
            $bondSelect.val(isin).trigger('change.select2');
            isSyncingFromTable = false;
            updateBondControlsFromCurrent();

            if (oldCurr !== newCurr) {
                syncBondCountForCurrency(newCurr);
            } else {
                const currentCount = parseInt($bondsCountInput.val(), 10) || getSavedBondCount(newCurr);
                const bondPrice = getBondPrice();
                const newAmount = currentCount * bondPrice;
                $amountInput.val(Math.round(newAmount));
                syncPresetButtonState(newAmount);
            }

            syncInflationInputsVisibility();
            recalculate(false);
            updateTableRealYields();
        }
    });

    // Smooth scroll and auto-expand guide accordion item
    $(document).on('click', '.ovdp-open-guide-link', function (e) {
        e.preventDefault();
        const targetItemId = $(this).data('target-item') || 'collapseFisher';
        const $targetCollapse = $(`#${targetItemId}`);
        const $guideSection = $('#ovdp-guide-section');

        if ($targetCollapse.length && window.bootstrap && typeof window.bootstrap.Collapse === 'function') {
            const collapseInstance = window.bootstrap.Collapse.getOrCreateInstance($targetCollapse[0], { toggle: false });
            collapseInstance.show();
        }

        if ($guideSection.length) {
            const targetOffset = $targetCollapse.length && $targetCollapse.closest('.accordion-item').length
                ? $targetCollapse.closest('.accordion-item').offset().top - 90
                : $guideSection.offset().top - 80;

            $('html, body').animate({
                scrollTop: Math.max(0, targetOffset)
            }, 400);
        }
    });

    // Vendor filter buttons (All, Diia military, Brokers)
    $vendorFilterBtns.on('click', function () {
        currentVendorFilter = $(this).data('vendor') || 'all';
        $vendorFilterBtns.removeClass('active btn-primary').addClass('btn-outline-primary');
        $(this).addClass('active btn-primary').removeClass('btn-outline-primary');
        filterTable();
    });

    function renderVendorsPanel(bond) {
        if (!$vendorsPanel.length || !bond) return;

        $panelIsin.text(bond.stockCode);
        if (bond.militaryName) {
            $panelMilName.text(bond.militaryName);
            $panelMilitaryBadge.removeClass('d-none');
        } else {
            $panelMilitaryBadge.addClass('d-none');
        }

        const textInStock = $container.data('text-vendor-in-stock') || 'В наявності';
        const textOpenLink = $container.data('text-vendor-open-link') || 'Купити';
        const textFee = $container.data('text-vendor-fee') || 'Комісія';

        $panelVendorsList.empty();
        const rawVendors = bond.availableVendors || [];
        const seenVendors = new Set();
        const vendors = [];
        for (const v of rawVendors) {
            if (v && v.vendorCode && !seenVendors.has(v.vendorCode)) {
                seenVendors.add(v.vendorCode);
                vendors.push(v);
            }
        }

        if (vendors.length === 0) {
            const emptyHtml = `
                <div class="p-2 border rounded bg-light text-center font-size-12 text-muted">
                    <div class="mb-1">Цей випуск доступний за індивідуальною заявкою через банки-первинні дилери або брокерів.</div>
                    <div class="d-flex justify-content-center gap-2 mt-2">
                        <a href="https://online.icu/" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-outline-primary py-0 px-2 font-size-11">
                            <i class="bx bx-link-external me-1"></i>ICU Trade
                        </a>
                        <a href="https://univer.ua/" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-outline-primary py-0 px-2 font-size-11">
                            <i class="bx bx-link-external me-1"></i>УНІВЕР
                        </a>
                    </div>
                </div>
            `;
            $panelVendorsList.append(emptyHtml);
            return;
        }

        vendors.forEach(v => {
            const hasQuotes = (v.secondaryPrice !== null && v.secondaryPrice !== undefined && v.secondaryPrice > 0) ||
                              (v.secondaryYield !== null && v.secondaryYield !== undefined && v.secondaryYield > 0);

            let badgeClass = 'ovdp-badge-default';
            let badgeText = v.badgeText;

            if (v.vendorCode === 'diia') {
                badgeClass = 'ovdp-badge-diia';
                badgeText = '🏛️ Дія';
            } else if (v.vendorCode === 'mono') {
                badgeClass = 'ovdp-badge-mono';
                badgeText = '🐱 mono';
            } else if (v.vendorCode === 'sense') {
                badgeClass = 'ovdp-badge-sense';
                badgeText = '🔴 Sense';
            } else if (v.vendorCode === 'icu') {
                badgeClass = 'ovdp-badge-icu';
                badgeText = '📈 ICU';
            } else if (v.vendorCode === 'univer') {
                badgeClass = 'ovdp-badge-univer';
                badgeText = '💼 УНІВЕР';
            } else {
                badgeText = badgeText || v.vendorName;
            }

            let secondaryQuotesHtml = '';
            if (hasQuotes) {
                secondaryQuotesHtml = `
                    <div class="bg-light p-1 px-2 rounded mb-2 font-size-11 d-flex flex-wrap gap-2 align-items-center">
                        ${v.secondaryPrice > 0 ? `<span class="text-body">Ціна: <strong>${Number(v.secondaryPrice).toFixed(2)} ₴</strong></span>` : ''}
                        ${v.secondaryYield > 0 ? `<span class="text-success">Дохідність: <strong>${Number(v.secondaryYield).toFixed(2)}%</strong></span>` : ''}
                    </div>
                `;
            }

            const textApplyQuote = $container.data('text-vendor-apply-quote') || 'Клікніть, щоб застосувати в розрахунок';

            const itemPrice = (v.secondaryPrice !== null && v.secondaryPrice !== undefined && v.secondaryPrice > 0)
                ? v.secondaryPrice
                : (bond.nominalValue || 1000);

            const itemYield = (v.secondaryYield !== null && v.secondaryYield !== undefined && v.secondaryYield > 0)
                ? v.secondaryYield
                : (bond.incomeLevel || 0);

            const itemHtml = `
                <div class="p-2 border rounded bg-white ovdp-vendor-card"
                     role="button"
                     data-price="${itemPrice}"
                     data-yield="${itemYield}"
                     data-bs-toggle="tooltip"
                     data-bs-container="body"
                     title="${textApplyQuote}">
                    <div class="d-flex align-items-center justify-content-between mb-1">
                        <div class="d-flex align-items-center">
                            <span class="ovdp-vendor-badge ${badgeClass} me-2">${badgeText}</span>
                            <strong class="font-size-13 ovdp-vendor-title">${v.vendorName}</strong>
                        </div>
                        <span class="badge bg-soft-success text-success font-size-10">${textInStock}</span>
                    </div>
                    ${v.appInstruction ? `<div class="font-size-11 text-muted mb-2">${v.appInstruction}</div>` : ''}
                    ${secondaryQuotesHtml}
                    <div class="d-flex align-items-center justify-content-between pt-1 border-top font-size-11">
                        <span class="text-muted">${v.feeDescription || '0% ' + textFee} • ${v.minAmount || 'від 1 000 ₴'}</span>
                        ${v.purchaseUrl ? `
                            <a href="${v.purchaseUrl}" target="_blank" rel="noopener noreferrer" class="btn btn-sm btn-primary py-0 px-2 font-size-11 ovdp-vendor-buy-link" onclick="event.stopPropagation();">
                                <i class="bx bx-link-external me-1"></i>${textOpenLink}
                            </a>
                        ` : ''}
                    </div>
                </div>
            `;
            $panelVendorsList.append(itemHtml);
        });
    }

    function formatDisplayDate(ts) {
        if (!ts) return '';
        const d = new Date(ts);
        if (isNaN(d.getTime())) return '';
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}.${month}.${year}`;
    }

    function formatMonthDay(val) {
        if (!val) return '';
        const ts = parseDateVal(val);
        if (!ts) return String(val);
        const d = new Date(ts);
        const day = d.getDate();
        const year = d.getFullYear();
        const currentYear = new Date().getFullYear();

        const isUk = (document.documentElement.lang || 'uk').toLowerCase().startsWith('uk');
        if (isUk) {
            const monthsUk = ['Січня', 'Лютого', 'Березня', 'Квітня', 'Травня', 'Червня', 'Липня', 'Серпня', 'Вересня', 'Жовтня', 'Листопада', 'Грудня'];
            const m = monthsUk[d.getMonth()] || '';
            if (year !== currentYear) {
                return `${day} ${m} ${year}`;
            }
            return `${day} ${m}`;
        }

        const locale = document.documentElement.lang || 'uk-UA';
        const opts = { day: 'numeric', month: 'short' };
        if (year !== currentYear) opts.year = 'numeric';
        return d.toLocaleDateString(locale, opts);
    }

    function renderPayoutTimeline(bond, bondCount, currSym) {
        try {
            if (!$payoutCardRow.length) return;
            if (!bond) {
                $payoutCardRow.hide();
                return;
            }

            $payoutCardRow.show();
            const rawPayments = bond.payments || bond.Payments || [];
            let payments = (Array.isArray(rawPayments) ? rawPayments : []).map(p => ({
                payDate: p.payDate || p.PayDate || '',
                parsedPayDate: p.parsedPayDate || p.ParsedPayDate || null,
                payType: parseInt(p.payType ?? p.PayType, 10) || 1,
                payVal: parseFloat(p.payVal ?? p.PayVal ?? 0) || 0,
                isFuture: Boolean(p.isFuture ?? p.IsFuture ?? false),
                daysUntil: parseInt(p.daysUntil ?? p.DaysUntil, 10) || 0
            })).filter(p => !!p.payDate);

            // Fallback: If payments array is empty, synthesize maturity redemption payment from bond
            if (payments.length === 0 && (bond.repayDate || bond.RepayDate)) {
                const rDate = bond.repayDate || bond.RepayDate;
                const rDays = bond.daysToRepay || bond.DaysToRepay || 0;
                const rNominal = bond.nominalValue || bond.NominalValue || 1000;
                payments = [{
                    payDate: rDate,
                    parsedPayDate: bond.parsedRepayDate || bond.ParsedRepayDate || null,
                    payType: 2,
                    payVal: rNominal,
                    isFuture: true,
                    daysUntil: rDays
                }];
            }

            if (payments.length === 0) {
                $payoutTimelineWrapper.addClass('d-none');
                $payoutEmptyState.removeClass('d-none');
                $payoutNextBadge.addClass('d-none');
                $payoutFrequencyText.text('--');
                $payoutSummaryCoupons.text('0');
                $payoutTableBody.empty();
                return;
            }

            $payoutTimelineWrapper.removeClass('d-none');
            $payoutEmptyState.addClass('d-none');

            const now = Date.now();
            const sortedPayments = [...payments].sort((a, b) => (parseDateVal(a.payDate) - parseDateVal(b.payDate)) || (a.payType - b.payType));

            let startTs = parseDateVal(bond.parsedIssueDate || bond.issueDate);
            let endTs = parseDateVal(bond.parsedRepayDate || bond.repayDate);

            if (!endTs || endTs <= 0) {
                endTs = parseDateVal(sortedPayments[sortedPayments.length - 1].payDate);
            }

            if (!startTs || startTs <= 0) {
                const firstPaymentTs = parseDateVal(sortedPayments[0].payDate);
                const periodDays = bond.payPeriodDays || 182;
                startTs = firstPaymentTs - (periodDays * 86400000);
            }

            if (endTs <= startTs) {
                endTs = startTs + 86400000;
            }

            const isFullyMatured = (bond.daysToRepay || 0) <= 0 && now >= endTs;
            const totalDurationMs = endTs - startTs;
            const elapsedMs = Math.max(0, Math.min(now - startTs, totalDurationMs));
            let elapsedPct = totalDurationMs > 0 ? Math.round((elapsedMs / totalDurationMs) * 100) : 0;

            if (!isFullyMatured) {
                // If bond has not matured yet, it is still active, so elapsed percentage cannot be 100%
                elapsedPct = Math.min(99, Math.max(0, elapsedPct));
            }

            // Visual progress bar width: if not fully matured, cap at 95% so there is always a clean visual gap before the final maturity flag
            const visualProgressWidth = isFullyMatured ? 100 : Math.min(95, elapsedPct);
            $timelineProgressBar.css('width', Math.max(0, visualProgressWidth) + '%');
            $timelineStartLabel.text(bond.issueDate ? (`${textPayoutStart}: ${bond.issueDate}`) : formatDisplayDate(startTs));
            $timelineEndLabel.text(bond.repayDate ? (`${textPayoutRedemptionLabel}: ${bond.repayDate}`) : formatDisplayDate(endTs));
            $timelineStatusLabel.text(elapsedPct + '% ' + textPayoutTimelineElapsed.toLowerCase());

            const coupons = sortedPayments.filter(p => p.payType === 1);
            const couponsCount = coupons.length;
            const futurePayments = sortedPayments.filter(p => p.isFuture || parseDateVal(p.payDate) >= now);
            const futureCouponsCount = futurePayments.filter(p => p.payType === 1).length;

            let freqText = '';
            if (bond.payPeriodDays && bond.payPeriodDays > 0) {
                const approxMonths = Math.round(bond.payPeriodDays / 30.4);
                freqText = `${textPayoutTotalCoupons}: ${couponsCount} (~${approxMonths} ${textMonths}) · ${textPayoutTimelineRemaining}: ${futureCouponsCount}`;
            } else {
                freqText = `${textPayoutTotalCoupons}: ${couponsCount} · ${textPayoutTimelineRemaining}: ${futureCouponsCount}`;
            }
            $payoutFrequencyText.text(freqText);
            $payoutSummaryCoupons.text(futureCouponsCount + ' / ' + couponsCount);

            const intermediateCoupons = sortedPayments.filter(p => p.payType === 1 && (endTs - parseDateVal(p.payDate)) > (86400000 * 3));
            const futureIntermediateCoupons = intermediateCoupons.filter(p => p.isFuture || parseDateVal(p.payDate) >= now);
            const isRedemptionNext = futurePayments.length > 0 && futureIntermediateCoupons.length === 0;

            const finalCoupon = sortedPayments.find(p => p.payType === 1 && Math.abs(parseDateVal(p.payDate) - endTs) <= (86400000 * 5));
            const investedPrincipal = bondCount * (bond.nominalValue || 1000);
            const finalTotalReceived = investedPrincipal + (finalCoupon ? (finalCoupon.payVal * bondCount) : 0);

            const nextPayment = futurePayments.length > 0 ? futurePayments[0] : null;
            if (isRedemptionNext) {
                const daysUntil = (bond.daysToRepay || 0) > 0 ? bond.daysToRepay : Math.max(0, Math.round((endTs - now) / 86400000));
                const dateFormatted = formatMonthDay(bond.repayDate || endTs);

                $payoutNextBadge.removeClass('d-none');
                $payoutNextBadge.removeClass('bg-soft-primary text-primary border-primary').addClass('bg-soft-warning text-dark border border-warning border-opacity-50');
                $payoutNextText.html(`<i class="bx bxs-flag-alt me-1 text-warning"></i>${textPayoutNextBadge}: ${dateFormatted} (${currSym} ${formatNumber(finalTotalReceived, 0)})` + (daysUntil > 0 ? ` ~${daysUntil} ${textDays}` : ''));
            } else if (nextPayment) {
                const pVal = parseFloat(nextPayment.payVal) || (nextPayment.payType === 2 ? (bond.nominalValue || 1000) : 0);
                const totalNextPayout = pVal * bondCount;
                const daysUntil = nextPayment.daysUntil || Math.max(0, Math.round((parseDateVal(nextPayment.payDate) - now) / 86400000));
                const dateFormatted = formatMonthDay(nextPayment.payDate);

                $payoutNextBadge.removeClass('d-none');
                $payoutNextBadge.removeClass('bg-soft-warning text-dark border-warning').addClass('bg-soft-primary text-primary border border-primary border-opacity-25');
                $payoutNextText.text(`${textPayoutNextBadge}: ${dateFormatted} (+${currSym} ${formatNumber(totalNextPayout, 0)})` + (daysUntil > 0 ? ` ~${daysUntil} ${textDays}` : ''));
            } else {
                $payoutNextBadge.addClass('d-none');
            }

            // Dispose previous timeline tooltips
            const bs = window.bootstrap;
            if (bs && bs.Tooltip) {
                $timelineNodes.find('[data-bs-toggle="tooltip"]').each(function () {
                    const inst = bs.Tooltip.getInstance(this);
                    if (inst) inst.dispose();
                });
            }
            $timelineNodes.empty();

            // 1. Render Start Node (0%)
            const startMonthDay = formatMonthDay(bond.issueDate || startTs);
            const $startNode = $(`
                <div class="ovdp-timeline-node ovdp-node-start" style="left: 0%;">
                    <span class="ovdp-timeline-dot ovdp-dot-start"
                          data-bs-toggle="tooltip"
                          data-bs-html="true"
                          data-bs-container="body"
                          title="${textPayoutStart}: ${bond.issueDate || formatDisplayDate(startTs)}"></span>
                    <div class="ovdp-timeline-node-info">
                        <div class="ovdp-node-date">${startMonthDay}</div>
                        <div class="ovdp-node-amount"><span class="badge bg-light text-muted fw-normal font-size-10">${textPayoutStart}</span></div>
                    </div>
                </div>
            `);
            $timelineNodes.append($startNode);

            // 2. Render Intermediate Coupons (strictly before maturity day, minimum 3 days buffer)
            let prevPosPct = 0;
            intermediateCoupons.forEach(p => {
                const pTs = parseDateVal(p.payDate);
                const rawPct = ((pTs - startTs) / totalDurationMs) * 100;
                let posPct = Math.max(3, Math.min(96, Math.round(rawPct * 10) / 10));
                if (posPct <= prevPosPct + 2) {
                    posPct = Math.min(96, prevPosPct + 2.5);
                }
                prevPosPct = posPct;

                const isPast = pTs < now && p !== nextPayment;
                const isNext = p === nextPayment;

                let dotClass = 'ovdp-dot-future';
                if (isNext) dotClass = 'ovdp-dot-next';
                else if (isPast) dotClass = 'ovdp-dot-done';

                const userCouponTotal = p.payVal * bondCount;
                const statusLabel = isPast
                    ? textPayoutPaidStatus
                    : (p.daysUntil > 0 ? ('~' + p.daysUntil + ' ' + textDays) : 'Сьогодні');

                const tooltipTitle = `${textPayoutCoupon}: ${p.payDate}<br><strong>+${currSym} ${formatNumber(userCouponTotal, 2)}</strong> (${formatNumber(bondCount, 0)} шт × ${currSym} ${formatNumber(p.payVal, 2)})<br><span class='text-muted font-size-11'>${statusLabel}</span>`;

                // CRITICAL: Do NOT show text labels under past coupons!
                // Only show label for next upcoming payout node, or future if very few.
                let infoHtml = '';
                if (isNext) {
                    infoHtml = `
                        <div class="ovdp-timeline-node-info ovdp-info-next">
                            <div class="ovdp-node-date text-primary fw-bold">${formatMonthDay(p.payDate)}</div>
                            <div class="ovdp-node-amount text-primary fw-bold">+${currSym} ${formatNumber(userCouponTotal, 0)}</div>
                        </div>
                    `;
                } else if (!isPast && futureCouponsCount <= 2) {
                    infoHtml = `
                        <div class="ovdp-timeline-node-info">
                            <div class="ovdp-node-date">${formatMonthDay(p.payDate)}</div>
                            <div class="ovdp-node-amount">+${currSym} ${formatNumber(userCouponTotal, 0)}</div>
                        </div>
                    `;
                }

                const $node = $(`
                    <div class="ovdp-timeline-node ${isNext ? 'ovdp-node-next' : (isPast ? 'ovdp-node-past' : '')}" style="left: ${posPct}%;">
                        <span class="ovdp-timeline-dot ${dotClass}"
                              data-bs-toggle="tooltip"
                              data-bs-html="true"
                              data-bs-container="body"
                              title="${tooltipTitle}"></span>
                        ${infoHtml}
                    </div>
                `);
                $timelineNodes.append($node);
            });

            // 3. Render Final Maturity Node (100%)
            let finalAmountText = '';
            if (finalCoupon) {
                finalAmountText = `${formatNumber(investedPrincipal, 0)} ${currSym} <span class="d-none d-sm-inline">${textPayoutPlusCoupon}</span>`;
            } else {
                finalAmountText = `${formatNumber(investedPrincipal, 0)} ${currSym}`;
            }

            const finalDaysLeft = (bond.daysToRepay || 0) > 0 ? ('~' + bond.daysToRepay + ' ' + textDays) : 'Сьогодні';
            const finalTooltip = `${textPayoutRedemptionLabel}: ${bond.repayDate || formatDisplayDate(endTs)}<br><strong>${currSym} ${formatNumber(finalTotalReceived, 2)}</strong>${finalCoupon ? (' (' + formatNumber(investedPrincipal, 0) + ' ' + currSym + ' + ' + textPayoutCoupon.toLowerCase() + ' ' + formatNumber(finalCoupon.payVal * bondCount, 0) + ' ' + currSym + ')') : ''}<br><span class='text-muted font-size-11'>${finalDaysLeft}</span>`;

            const $finalNode = $(`
                <div class="ovdp-timeline-node ovdp-node-final ${isRedemptionNext ? 'ovdp-node-next' : ''}" style="left: 100%;">
                    <span class="ovdp-timeline-dot ovdp-dot-final ${isRedemptionNext ? 'ovdp-dot-final-next' : ''}"
                          data-bs-toggle="tooltip"
                          data-bs-html="true"
                          data-bs-container="body"
                          title="${finalTooltip}"><i class="bx bxs-flag-alt"></i></span>
                    <div class="ovdp-timeline-node-info ovdp-info-final ${isRedemptionNext ? 'ovdp-info-next' : ''}">
                        <div class="ovdp-node-date ${isRedemptionNext ? 'text-warning fw-bold' : ''}">${formatMonthDay(bond.repayDate || endTs)}</div>
                        <div class="ovdp-node-amount ${isRedemptionNext ? 'text-warning fw-bold' : ''}">${finalAmountText}</div>
                    </div>
                </div>
            `);
            $timelineNodes.append($finalNode);

            // Initialize tooltips for newly added nodes
            if (bs && bs.Tooltip) {
                $timelineNodes.find('[data-bs-toggle="tooltip"]').each(function () {
                    new bs.Tooltip(this, { container: 'body', trigger: 'hover' });
                });
            }

            // Render detailed schedule table (newest / future records on top)
            $payoutTableBody.empty();
            const tablePayments = [...sortedPayments].sort((a, b) => (parseDateVal(b.payDate) - parseDateVal(a.payDate)) || (b.payType - a.payType));
            tablePayments.forEach(p => {
                const pTs = parseDateVal(p.payDate);
                const isPast = pTs < now && p !== nextPayment;
                const isNext = p === nextPayment;
                const isFinal = p.payType === 2;

                let rowClass = '';
                if (isNext) rowClass = 'ovdp-payout-row-next';
                else if (isPast) rowClass = 'ovdp-payout-row-past text-muted';

                const pVal = parseFloat(p.payVal) || (isFinal ? (bond.nominalValue || 1000) : 0);
                const userTotal = pVal * bondCount;
                const pTypeBadge = isFinal
                    ? `<span class="ovdp-payout-type-badge ovdp-badge-redemption" data-bs-toggle="tooltip" data-bs-container="body" title="${textPayoutRedemptionLabel}"><i class="bx bxs-flag-alt me-1"></i><span class="d-none d-sm-inline">${textPayoutRedemptionLabel}</span></span>`
                    : `<span class="ovdp-payout-type-badge ovdp-badge-coupon" data-bs-toggle="tooltip" data-bs-container="body" title="${textPayoutCoupon}"><i class="fas fa-coins me-1"></i><span class="d-none d-sm-inline">${textPayoutCoupon}</span></span>`;

                let daysLabel = '';
                if (isNext) {
                    const daysUntil = p.daysUntil || Math.max(0, Math.round((pTs - now) / 86400000));
                    daysLabel = `<span class="badge bg-primary text-white font-size-10 text-nowrap"><i class="bx bx-bell me-1"></i><span class="d-none d-sm-inline">${textPayoutNextBadge} </span>~${daysUntil} ${textDays}</span>`;
                } else if (isPast) {
                    daysLabel = `<span class="badge bg-light text-muted font-size-10">${textPayoutPaidStatus}</span>`;
                } else {
                    const daysUntil = p.daysUntil || Math.max(0, Math.round((pTs - now) / 86400000));
                    daysLabel = `<span class="badge bg-soft-secondary text-muted font-size-10">~${daysUntil} ${textDays}</span>`;
                }

                const displayPayDate = formatDisplayDate(pTs) || p.payDate;
                const rowHtml = `
                    <tr class="${rowClass}">
                        <td>
                            <span class="font-monospace fw-semibold font-size-13">${displayPayDate}</span>
                            <div class="mt-1">${daysLabel}</div>
                        </td>
                        <td class="text-center align-middle">${pTypeBadge}</td>
                        <td class="text-end">
                            <div class="fw-bold text-${isFinal ? 'primary' : 'success'} font-size-13">+${currSym} ${formatNumber(userTotal, 2)}</div>
                            <div class="font-size-11 text-muted">(${currSym} ${formatNumber(pVal, 2)} / шт)</div>
                        </td>
                    </tr>
                `;
                $payoutTableBody.append(rowHtml);
            });

            // Initialize tooltips for schedule table badges
            if (bs && bs.Tooltip) {
                $payoutTableBody.find('[data-bs-toggle="tooltip"]').each(function () {
                    new bs.Tooltip(this, { container: 'body', trigger: 'hover' });
                });
            }
        } catch (err) {
            console.error('Error rendering payout timeline:', err);
        }
    }

    // Toggle icon rotation on collapse
    $('#ovdp-payout-details-collapse').on('show.bs.collapse', function () {
        $payoutToggleIcon.removeClass('bx-chevron-down').addClass('bx-chevron-up');
    }).on('hide.bs.collapse', function () {
        $payoutToggleIcon.removeClass('bx-chevron-up').addClass('bx-chevron-down');
    });

    // Click on vendor card to apply price & yield to calculator inputs (custom quote or default bond nominal/yield)
    $(document).on('click', '.ovdp-vendor-card', function (e) {
        if ($(e.target).closest('.ovdp-vendor-buy-link').length) {
            return;
        }

        const price = parseFloat($(this).data('price'));
        const yieldVal = parseFloat($(this).data('yield'));

        if (!isNaN(price) && price > 0) {
            $bondPriceInput.val(price.toFixed(2));
        }

        if (!isNaN(yieldVal) && yieldVal >= 0) {
            $yieldInput.val(yieldVal.toFixed(2));
        }

        $('.ovdp-vendor-card').removeClass('active');
        $(this).addClass('active');

        recalculate(false);

        // Flash pulse effect on the updated inputs
        $bondPriceInput.removeClass('ovdp-input-flash');
        $yieldInput.removeClass('ovdp-input-flash');
        if ($bondPriceInput.length) {
            void $bondPriceInput[0].offsetWidth; // trigger reflow
            $bondPriceInput.addClass('ovdp-input-flash');
        }
        if ($yieldInput.length) {
            void $yieldInput[0].offsetWidth; // trigger reflow
            $yieldInput.addClass('ovdp-input-flash');
        }
        setTimeout(() => {
            $bondPriceInput.removeClass('ovdp-input-flash');
            $yieldInput.removeClass('ovdp-input-flash');
        }, 900);
    });

    // Quick vendor button in table row click handler
    $(document).on('click', '.ovdp-btn-quick-vendor', function (e) {
        e.stopPropagation();
        const isin = $(this).data('isin');
        if (!isin) return;

        const bond = allBonds.find(b => b.stockCode === isin);
        if (bond) {
            const oldCurr = getBondCurrency();
            const newCurr = (bond.valCode || 'UAH').toUpperCase();
            if (oldCurr !== newCurr) {
                const currentCount = parseInt($bondsCountInput.val(), 10);
                if (!isNaN(currentCount) && currentCount > 0) {
                    saveBondCount(oldCurr, currentCount);
                }
            }

            currentBond = bond;
            if (currentCurrency !== 'ALL' && currentBond.valCode !== currentCurrency) {
                currentCurrency = currentBond.valCode;
                $currencyTabs.removeClass('active');
                $(`.ovdp-currency-tab[data-currency="${currentBond.valCode}"]`).addClass('active');
                populateBondSelect(currentBond.valCode);
                filterTable();
            }

            isSyncingFromTable = true;
            $bondSelect.val(isin).trigger('change.select2');
            isSyncingFromTable = false;
            updateBondControlsFromCurrent();

            if (oldCurr !== newCurr) {
                syncBondCountForCurrency(newCurr);
            } else {
                const currentCount = parseInt($bondsCountInput.val(), 10) || getSavedBondCount(newCurr);
                const bondPrice = getBondPrice();
                const newAmount = currentCount * bondPrice;
                $amountInput.val(Math.round(newAmount));
                syncPresetButtonState(newAmount);
            }

            syncInflationInputsVisibility();
            recalculate(false);
            updateTableRealYields();

            // Highlight and pulse the vendor panel
            if ($vendorsPanel.length) {
                $vendorsPanel.removeClass('ovdp-panel-pulse');
                void $vendorsPanel[0].offsetWidth; // trigger reflow
                $vendorsPanel.addClass('ovdp-panel-pulse');

                $('html, body').animate({
                    scrollTop: $vendorsPanel.offset().top - 80
                }, 350);
            }
        }
    });

    function initTooltips() {
        const bs = window.bootstrap;
        if (bs && bs.Tooltip) {
            const tooltipTriggerList = [].slice.call(document.querySelectorAll('#ovdp-calculator-app [data-bs-toggle="tooltip"]'));
            tooltipTriggerList.forEach(function (el) {
                const existing = bs.Tooltip.getInstance(el);
                if (existing) {
                    existing.dispose();
                }
                new bs.Tooltip(el, {
                    container: 'body',
                    popperConfig: function (defaultBsPopperConfig) {
                        return {
                            ...defaultBsPopperConfig,
                            strategy: 'fixed'
                        };
                    }
                });
            });
        }
    }

    // Initial setup
    populateBondSelect(currentCurrency);
    filterTable();
    updateBondControlsFromCurrent();

    const initialCurrency = getBondCurrency();
    const initialCount = getSavedBondCount(initialCurrency);
    const initialBondPrice = getBondPrice();
    const initialAmount = initialCount * initialBondPrice;

    $bondsCountInput.val(initialCount);
    $amountInput.val(Math.round(initialAmount));

    renderPresets(initialCurrency, initialAmount);
    syncPresetButtonState(initialAmount);
    syncInflationInputsVisibility();
    recalculate(false);
    updateTableRealYields();
    initTooltips();
    initOvdpSavePanel();

    // Mode-specific landing view initialization
    const calculatorMode = String($container.data('calculator-mode') || 'returns').toLowerCase();
    if (calculatorMode === 'military') {
        const $diiaBtn = $('.ovdp-vendor-filter-btn[data-vendor="diia"]');
        if ($diiaBtn.length) {
            $diiaBtn.trigger('click');
        }
    } else if (calculatorMode === 'payments') {
        const $details = $('#ovdp-payout-details-collapse');
        if ($details.length && !$details.hasClass('show')) {
            const bs = window.bootstrap;
            if (bs && bs.Collapse) {
                new bs.Collapse($details[0], { toggle: true });
            } else {
                $details.addClass('show');
            }
        }
    }
});
